import React from "react";

import ImageContainer from "./ImageContainer";
import QuestionContainer from "./QuestionContainer";

import { GameContext } from "../../context/GameContext";

const Playground = () => {
  const { deskQuest } = React.useContext(GameContext);

  return <>{deskQuest ? <QuestionContainer /> : <ImageContainer />}</>;
};

export default Playground;
